import classNames from 'classnames';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { splitProductTitle } from './helpers';
import { priceFormatSuperscript } from '@/lib/price';
import { priceFormater } from '@/settings/index';
import PricingBoxComparePrice from './PricingBoxComparePrice';
import BeforeTradeIn from './BeforeTradeIn';
import AddToCartLink from '@/components/v2/product/AddToCartLink';
import PricingBoxDelivery from './PricingBoxDelivery';
import PayLaterMessage from './PayLaterMessage';
import PrimaryTitleWithBadge from './PrimaryTitleWithBadge';

const Summary = () => {
  const {
    selectedSkuDetails: { title, compareAtPrice, finalPrice },
    selectedOffer,
    selectedWarranty,
    isFetchingSku,
  } = useProductPageContext();
  const { primaryTitle, secondaryTitle, showUnlocked } =
    splitProductTitle(title);
  const hasComparePrice = Boolean(compareAtPrice && compareAtPrice > 0);

  return (
    <div
      className={classNames('px-5 lg:hidden lg:px-0', {
        'opacity-60': isFetchingSku,
      })}
    >
      <div className="rounded-md border border-gray-700 p-4 text-gray-700">
        <div
          className="relative min-w-0 text-lg font-bold leading-none text-gray-700"
          id="e2e-pdp-title"
        >
          <PrimaryTitleWithBadge
            primaryTitle={primaryTitle}
            showUnlocked={showUnlocked}
          />
        </div>
        {secondaryTitle && (
          <div className="mt-1 text-xs font-medium leading-tight text-gray-700">
            {secondaryTitle}
          </div>
        )}

        <div className="mt-4 flex flex-col gap-y-1">
          {finalPrice > 0 && (
            <div className="flex items-baseline gap-2">
              <div className="text-base font-bold leading-none" translate="no">
                {priceFormatSuperscript(priceFormater.long(finalPrice))}
              </div>
              <BeforeTradeIn />
            </div>
          )}
          {hasComparePrice && <PricingBoxComparePrice align="left" />}
        </div>
        <PayLaterMessage amount={finalPrice} align="left" className="mt-4" />
      </div>
      <div className="mt-4 flex flex-col items-center gap-1.5 self-center">
        <AddToCartLink
          testingId="e2e-pdp-add-to-cart"
          className="w-full"
          id="purchaseCont"
          offer={selectedOffer}
          selectedWarranty={selectedWarranty}
        />
      </div>
      <PricingBoxDelivery align="center" className="mt-4 text-xs" />
    </div>
  );
};

export default Summary;
